import { TReplaceOptions } from '../models/replaceOptions'

export const replaceKeysInTranslation = (
  translatedText: string,
  replaceParams?: TReplaceOptions[]
) => {
  let result = translatedText
  if (replaceParams) {
    replaceParams.forEach((item) => {
      result = result.replaceAll(item.key, item.value)
    })
  }
  return result
}
